import type { Api } from '@cocoonspace/types/shared/api'
import type { AxiosInstance, AxiosRequestConfig } from 'axios'

import { defineEndpoint } from '../utils/define-endpoint'

export interface UpdateBooking {
	uriParams: Api.Operations['updateBooking']['parameters']['path']
	body: NonNullable<
		Api.Operations['updateBooking']['requestBody']
	>['content']['application/json']
	response: Api.Operations['updateBooking']['responses']['200']['content']['application/json']
}

export const updateBooking = (
	axiosInstance: AxiosInstance,
	overideConfig?: AxiosRequestConfig,
) =>
	defineEndpoint<UpdateBooking>(
		{
			method: 'patch',
			url: '/bookings/{bookingId}',
			...overideConfig,
		},
		axiosInstance,
	)
